import React from "react";

/**
 * Pill shown in the Payments banner. Reflects the live subscription state:
 * the plan name + status when subscribed, "No active subscription" otherwise.
 */
const SubscriptionStatusPill = ({ subscription, planName }) => {
  const status = (subscription?.status ?? "").toLowerCase();
  const isLive = ["active", "trialing"].includes(status);

  const label = isLive
    ? `${planName ?? "Subscription"} · ${status === "trialing" ? "Trial" : "Active"}`
    : "No active subscription";

  return (
    <span
      className="d-inline-flex align-items-center gap-2 rounded-pill px-3 py-2 fw-semibold"
      style={{
        background: "rgba(255,255,255,0.18)",
        border: "1px solid rgba(255,255,255,0.35)",
        color: "#FFFFFF",
        fontSize: "0.82rem",
        whiteSpace: "nowrap",
      }}
    >
      <span
        style={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          background: isLive ? "#32D583" : "rgba(255,255,255,0.6)",
          flexShrink: 0,
        }}
      />
      {label}
    </span>
  );
};

export default SubscriptionStatusPill;
